import { up, down } from 'slide-element';
import geolocate, { geocodeAddress, setCoordinatesCookie } from './geolocation';

const $btnGeolocate = document.querySelector('.hub-filters .btn-geolocate');
const $warning = document.querySelector('.hub-filters-geolocation-warning');
const $closeBtnWarning = $warning?.querySelector('.btn-close-warning');
const $proximityForm = document.querySelector('.hub-filters-proximity');
const $addressInput = $proximityForm?.querySelector('input[name="adresse"]');
const $addressError = $proximityForm?.querySelector('.hub-filters-error');
const PERMISSION_DENIED = 1; // GeolocationPositionError.PERMISSION_DENIED
const SORTED_BY_ADDRESS_KEY = 'fadoq_sorted_by_address';

function isSortedByAddress() {
    try {
        return localStorage.getItem(SORTED_BY_ADDRESS_KEY) === '1';
    } catch {
        return false;
    }
}

function setSortedByAddress(sorted) {
    try {
        if (sorted) {
            localStorage.setItem(SORTED_BY_ADDRESS_KEY, '1');
        } else {
            localStorage.removeItem(SORTED_BY_ADDRESS_KEY);
        }
    } catch {
        // storage unavailable: the check mark follows the permission only.
    }
}

function showWarning() {
    if (!$warning || $warning.classList.contains('visible')) return;

    $warning.classList.add('visible');
    down($warning, { display: 'flex' });
}

function hideWarning() {
    if (!$warning || !$warning.classList.contains('visible')) return;

    $warning.classList.remove('visible');
    up($warning);
}

function setDenied() {
    if (!$btnGeolocate) return;

    $btnGeolocate.classList.remove('is-located');
    $btnGeolocate.disabled = true;
    showWarning();
}

function setGranted() {
    if (!$btnGeolocate) return;

    $btnGeolocate.classList.toggle('is-located', !isSortedByAddress());
    $btnGeolocate.disabled = false;
    hideWarning();
}

function setReadyToLocate() {
    if (!$btnGeolocate) return;

    $btnGeolocate.classList.remove('is-located');
    $btnGeolocate.disabled = false;
    hideWarning();
}

function handleGeolocationError(error) {
    if (error && error.code !== PERMISSION_DENIED) {
        showWarning();
        return;
    }

    setDenied();
}

function applyPermissionState(state) {
    if (state === 'granted') {
        setGranted();
    } else if (state === 'denied') {
        setDenied();
    } else {
        setReadyToLocate();
    }
}

async function watchPermission() {
    if (!navigator.permissions?.query) return;

    try {
        const permission = await navigator.permissions.query({ name: 'geolocation' });
        applyPermissionState(permission.state);
        permission.addEventListener('change', () => applyPermissionState(permission.state));
    } catch {
        // leave the button in its default state.
    }
}

if ($btnGeolocate) {
    if (!navigator.geolocation) {
        setDenied();
    } else {
        watchPermission();
    }

    // Geolocation stores the coordinates and region, then reloads the page without the
    // search parameters so the results are sorted by proximity to the new position.
    $btnGeolocate.addEventListener('click', () => {
        geolocate({
            onError: handleGeolocationError,
            onSuccess: () => {
                setSortedByAddress(false);
                setGranted();
            },
            redirectUrl: `${window.location.pathname.replace(/\/page\/\d+\/?$/, '/')}#hub-filters`,
        });
    });
}

$closeBtnWarning?.addEventListener('click', () => {
    hideWarning();
});

function setAddressError(visible) {
    if (!$addressError) return;

    $addressError.hidden = !visible;
    $addressInput?.setAttribute('aria-invalid', visible ? 'true' : 'false');
}

// The address is geocoded here, stored in the coordinates cookie, then the form is
// submitted: the server sorts the clubs by distance from that cookie.
$proximityForm?.addEventListener('submit', async (e) => {
    const address = $addressInput?.value.trim();
    const wasLocated = $btnGeolocate?.classList.contains('is-located');

    $btnGeolocate?.classList.remove('is-located');

    // No address: plain submit, sorted by the position already stored (if any).
    if (!address) {
        setSortedByAddress(true);
        return;
    }

    e.preventDefault();
    setAddressError(false);

    const $submit = $proximityForm.querySelector('[type="submit"]');
    $submit.disabled = true;

    try {
        const { lat, lng } = await geocodeAddress(address);
        setCoordinatesCookie(lat, lng);
        setSortedByAddress(true);
        // form.submit() doesn't fire the submit event again.
        $proximityForm.submit();
    } catch {
        setAddressError(true);
        $btnGeolocate?.classList.toggle('is-located', wasLocated);
        $submit.disabled = false;
        $addressInput.focus();
    }
});

$addressInput?.addEventListener('input', () => {
    setAddressError(false);
    $btnGeolocate?.classList.remove('is-located');
});

const $resultsLabel = document.querySelector('.hub-filters-results-label');

document.querySelector('.hub-filters-tabs-btns')?.addEventListener('tabchange', (e) => {
    if (!$resultsLabel) return;

    const { labelName, labelProximity } = $resultsLabel.dataset;
    const isNameTab = e.detail.tab.id === 'hub-filters-tab-name';
    $resultsLabel.textContent = isNameTab ? labelName : labelProximity;
});
